const Teams = {
  ALDOSIVI: "Aldosivi",
  ARGENTINOS_JRS: "Argentinos Juniors",
  ATLETICO_TUCUMAN: "Atlético Tucumán",
  BANFIELD: "Banfield",
  BARRACAS_CENTRAL: "Barracas Central",
  BELGRANO: "Belgrano",
  BOCA_JRS: "Boca Juniors",
  CENTRAL_CORDOBA: "Central Córdoba (SdE)",
  DEFENSA_Y_JUSTICIA: "Defensa y Justicia",
  RIESTRA: "Deportivo Riestra",
  ESTUDIANTES_LP: "Estudiantes de La Plata",
  ESTUDIANTES_RC: "Estudiantes de Río Cuarto",
  GIMNASIA_LP: "Gimnasia y Esgrima La Plata",
  GIMNASIA_MENDOZA: "Gimnasia y Esgrima de Mendoza",
  HURACAN: "Huracán",
  INDEPENDIENTE: "Independiente",
  INDEPENDIENTE_RIVADAVIA: "Independiente Rivadavia",
  INSTITUTO_CBA: "Instituto",
  LANUS: "Lanús",
  NEWELLS_OLD_BOYS: "Newell's Old Boys",
  PLATENSE: "Platense",
  RACING_CLUB: "Racing Club",
  RIVER_PLATE: "River Plate",
  ROSARIO_CENTRAL: "Rosario Central",
  SAN_LORENZO: "San Lorenzo",
  SARMIENTO: "Sarmiento de Junín",
  TALLERES: "Talleres de Córdoba",
  TIGRE: "Tigre",
  UNION: "Unión de Santa Fe",
  VELEZ: "Vélez Sarsfield",
};

export default Teams;
